var map = {
	"./barredores.svg": 527,
	"./bascula.svg": 4371,
	"./calendario.svg": 2298,
	"./choferes.svg": 687,
	"./clientes.svg": 861,
	"./desechos.svg": 5794,
	"./flota.svg": 7288,
	"./home.svg": 2717,
	"./identificadores.svg": 9867,
	"./monitoreo.svg": 9814,
	"./pesajes.svg": 8013,
	"./planes.svg": 2217,
	"./rastreadores.svg": 85,
	"./reportes.svg": 3438,
	"./servicios.svg": 4099,
	"./supervision.svg": 8805,
	"./usuarios.svg": 4267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7358;